import React, {useEffect} from 'react';
import {FormattedMessage} from 'react-intl';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {PaymentBitContextProvider} from '../../contexts/PaymentBitContext';
import {PaymentCreditCardContextProvider} from '../../contexts/PaymentCreditCardContex';
import {PaymentRecurringContextProvider} from '../../contexts/PaymentRecurringContext';
import {PaymentPaypalContextProvider} from '../../contexts/PaymentPaypalContext';
import {PaymentContextProvider} from '../../contexts/PaymentContext';
import PageHeader from '../../../../common/components/ui/PageHeader';
import SectionPanel from '../../../../common/components/ui/SectionPanel';
import Tabs from '../../../../common/components/ui/Tabs';
import FieldInvoiceCreditCard from '../../components/FieldInvoiceCreditCard';
import FieldCustomerLinkCreditCard from '../../components/FieldCustomerLinkCreditCard';
import FieldInvoicePaypal from '../../components/FieldInvoicePaypal';
import FieldCustomerLinkPaypal from '../../components/FieldCustomerLinkPaypal';
import FieldCustomerName from '../../components/FieldCustomerName';
import FieldService from '../../components/FieldService';
import FieldEmail from '../../components/FieldEmail';
import FieldPhone from '../../components/FieldPhone';
import FieldAmount from '../../components/FieldAmount';
import FieldCurrency from '../../components/FieldCurrency';
import FieldCurrencyR from '../../components/FieldCurrencyR';
import FieldPayerIsCustomer from '../../components/FieldPayerIsCustomer';
import FieldPayerName from '../../components/FieldPayerName';
import FieldPayerEmail from '../../components/FieldPayerEmail';
import FieldPayerPhone from '../../components/FieldPayerPhone';
import PaymentPageTitle from '../../components/PaymentPageTitle';
import PaymentLink from '../../components/PaymentLink';
import FooterDivider from '../../../../common/components/ui/FooterDivider';
import FooterLogo from '../../../../common/components/ui/FooterLogo';
import FieldStartDate from '../../components/FieldStartDate';
import FieldDescription from '../../components/FieldDescription';
import FieldPaymentsCount from '../../components/FieldPaymentsCount';
import FieldRecurringPeriod from '../../components/FieldRecurringPeriod';
import FieldCurrencyPaypal from '../../components/FieldCurrencyPaypal';
import PaypalLink from '../../components/PaypalLink';
import ButtonSubmitBit from '../../components/ButtonSubmitBit';
import ButtonSubmitCreditCard from '../../components/ButtonSubmitCreditCard';
import ButtonSubmitRecurring from '../../components/ButtonSubmitRecurring';
import ButtonSubmitPaypal from '../../components/ButtonSubmitPaypal';
import styles from './Payment.module.scss';
import FieldCustomerAddress from "../../components/FieldCustomerAddress";
import FieldCustomerIdNumber from "../../components/FieldCustomerIdNumber";

const Payment = () => {
  const {setPageTitle} = useGlobalContext();

  useEffect(() => {
    setPageTitle((<PageHeader id={'payment-page-header'} defaultMessage={'Credit clearance'}/>));
  }, []);

  return (
    <PaymentContextProvider>
      <SectionPanel>
        <PaymentPageTitle/>
        <Tabs
          tabs={[
            {
              label: <FormattedMessage id={'payment-form-creditCard'} defaultMessage={'Credit card'}/>,
              content: (
                <PaymentCreditCardContextProvider>
                  <div className={styles.form}>
                    <div className={styles.column}>
                      <FieldInvoiceCreditCard/>
                      <FieldCustomerLinkCreditCard/>
                      <FieldCustomerName/>
                      <FieldEmail/>
                      <FieldPhone/>
                      <FieldPayerIsCustomer/>
                      <FieldPayerName/>
                      <FieldPayerEmail/>
                      <FieldPayerPhone/>
                    </div>
                    <div className={styles.column}>
                      <FieldService/>
                      <FieldAmount/>
                      <FieldCurrency/>
                      <ButtonSubmitCreditCard/>
                    </div>
                  </div>
                </PaymentCreditCardContextProvider>
              )
            },
            {
              label: <FormattedMessage id={'payment-form-bit'} defaultMessage={'Bit'}/>,
              content: (
                <PaymentBitContextProvider>
                  <div className={styles.form}>
                    <div className={styles.column}>
                      <FieldCustomerName/>
                      <FieldEmail/>
                      <FieldPhone/>
                      <FieldCustomerAddress/>
                      <FieldCustomerIdNumber/>
                    </div>
                    <div className={styles.column}>
                      <FieldService/>
                      <FieldAmount/>
                      <ButtonSubmitBit/>
                    </div>
                  </div>
                </PaymentBitContextProvider>
              )
            },
            {
              label: <FormattedMessage id={'payment-form-recurring'} defaultMessage={'Recurring'}/>,              content: (
                <PaymentRecurringContextProvider>
                  <div className={styles.form}>
                    <div className={styles.column}>
                      <FieldCustomerName/>
                      <FieldEmail/>
                      <FieldPhone/>
                      <FieldDescription/>
                      <FieldAmount/>
                      <FieldCurrencyR/>
                    </div>
                    <div className={styles.column}>
                      <FieldStartDate/>
                      <FieldRecurringPeriod/>
                      <FieldPaymentsCount/>
                      <ButtonSubmitRecurring/>
                    </div>
                  </div>
                </PaymentRecurringContextProvider>
              )
            },
            {
              label: <FormattedMessage id={'payment-form-paypal'} defaultMessage={'PayPal'}/>,
              content: (
                <PaymentPaypalContextProvider>
                  <div className={styles.form}>
                    <div className={styles.column}>
                      <FieldInvoicePaypal/>
                      <FieldCustomerLinkPaypal/>
                      <FieldCustomerName/>
                      <FieldEmail/>
                      <FieldPhone/>
                    </div>
                    <div className={styles.column}>
                      <FieldAmount/>
                      <FieldCurrencyPaypal/>
                      <FieldDescription/>
                      <ButtonSubmitPaypal/>
                    </div>
                  </div>
                  <PaypalLink/>
                </PaymentPaypalContextProvider>
              )
            },
          ]}
        />
        <PaymentLink/>
        <div className={styles.lines}>
          <div className={styles.line}>
            <FormattedMessage
              id={'payment-text-line1'}
            />
          </div>
          <div className={styles.line}>
            <FormattedMessage
              id={'payment-text-line2'}
            />
          </div>
          <div className={styles.line}>
            <FormattedMessage
              id={'payment-text-line3'}
            />
          </div>
        </div>
      </SectionPanel>
      <FooterDivider/>
      <FooterLogo/>
    </PaymentContextProvider>
  );
};

export default Payment;